export default __webpack_public_path__ + "static/media/Exclusive.f93bd300.png";